import type { RouteLocationNormalizedLoaded, Router } from 'vue-router';
import { getAuthSessionManager } from '@/utils/authSessionManager';

function routeRequiresAuth(route: RouteLocationNormalizedLoaded): boolean {
  return route.matched.some((record) => record.meta.requiresAuth);
}

async function applySharedLogoutMarkerOnResume(router: Router): Promise<void> {
  if (!(await getAuthSessionManager().applySharedLogoutMarkerIfNeeded())) {
    return;
  }

  if (routeRequiresAuth(router.currentRoute.value)) {
    await router.replace('/');
  }
}

export function setupAuthSessionLifecycle(router: Router): void {
  window.addEventListener('focus', () => {
    void applySharedLogoutMarkerOnResume(router);
  });

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      void applySharedLogoutMarkerOnResume(router);
    }
  });
}
